import NotFoundBlock from "../components/notFoundBlock/NotFoundBlock";


let NotFound = () => {
    return (
        <div>
            <NotFoundBlock />
        </div>
    )
}

export default NotFound;